export default {
    deviceId: '', //设备唯一标识
    uuid: JSON.parse(localStorage.getItem('uuid')) || '',
    userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
    noticeInfo: JSON.parse(localStorage.getItem('noticeInfo')) || {},
    recents: JSON.parse(localStorage.getItem('recents')) || [],
    historyGames: JSON.parse(localStorage.getItem('historyGames')) || [],
    homeGames: JSON.parse(localStorage.getItem('homeGames')) || [],
    configInfo: JSON.parse(localStorage.getItem('configInfo')) || {},
}


// WEBPACK FOOTER //
// ./src/store/state.js